export default "__VITE_ASSET__c06cd392__"